import { auth0AppClient } from "#src/auth/auth0-app-client";
import { ExceptionUtils } from "#src/utils/exception";
import { Location } from "history";

export function signIn(email = "") {
  ExceptionUtils.registerLifecycleEvent({
    category: "app",
    type: "info",
    message: "Redirecting to login",
  });

  return () => {
    auth0AppClient.loginWithRedirect({
      authorizationParams: { login_hint: email },
    });
  };
}

export const signOut = () => () => {
  ExceptionUtils.teardown();
  auth0AppClient.logout({
    logoutParams: {
      returnTo: `${window.location.origin}/app/logout`,
    },
  });
};

export const saveEntryLocation = (entryLocation) => (dispatch) => {
  const asString = JSON.stringify(entryLocation);
  dispatch({
    type: "ENTRY_LOCATION_SAVED",
    location: asString,
  });

  return sessionStorage.setItem("auth--entryLocation", asString);
};

export const popEntryLocation = () => (dispatch) => {
  const fromSession = sessionStorage.getItem("auth--entryLocation");
  sessionStorage.removeItem("auth--entryLocation");
  try {
    const parsed = fromSession ? (JSON.parse(fromSession) as Location) : null;

    dispatch({
      type: "ENTRY_LOCATION_RETRIEVED",
      location: parsed,
    });

    return parsed;
  } catch (e) {
    return null;
  }
};
